import React from "react";
import { CustomCard } from "../../CustomCard";
import { Box, Divider } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

const FeaturesOverviewComponentSkeleton = ({}) => {
  const styles = useStyles();
  return (
    <CustomCard
      borderRadius="xl"
      borderColor="secondary"
      classes={styles.containerFeaturOverView}
    >
      <Box className={styles.containerHeader}>
        <Skeleton variant="text" width={100} height={24} />
        <Divider />
      </Box>
      <Box className={styles.containerBody}>
        <Box className={styles.containerRow}>
          <Box className={styles.containerItems}>
            <Skeleton variant="text" width={25} height={30} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box className={styles.containerItems}>
            <Skeleton variant="text" width={25} height={30} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
        </Box>
        <Box className={styles.containerRow}>
          <Box className={styles.containerItems}>
            <Skeleton variant="text" width={25} height={30} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box className={styles.containerItems}>
            <Skeleton variant="text" width={25} height={30} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
        </Box>
        <Box className={styles.containerRow}>
          <Box className={styles.containerItems}>
            <Skeleton variant="text" width={25} height={30} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box className={styles.containerItems}>
            <Skeleton variant="text" width={25} height={30} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
        </Box>
        <Box className={styles.containerRow}>
          <Box className={styles.containerItems}>
            <Skeleton variant="text" width={25} height={30} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box className={styles.containerItems}>
            <Skeleton variant="text" width={25} height={30} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
        </Box>
      </Box>
    </CustomCard>
  );
};

export default FeaturesOverviewComponentSkeleton;
